module.exports = __webpack_public_path__ + "media/scanner/history-yellow-17b25731.png";